import mediaQueries from '../media-queries';

export function getMediaQuery(name: string) {
  const suffix = name.split('_').pop()?.replace('.css', '');
  return Object.entries(mediaQueries).find(
    ([mediaQueryName]) => mediaQueryName === suffix,
  )?.[1];
}
